// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Qqh8H","title":"AfterFrontImage_title__3rU8T"};